import { Option } from 'commander';
import type { CommandInitFunction } from '../../types/CommandInitFunction.js';
import type { SetupOptions } from './execute.js';

/** Defines the "setup" verb. */
export const init: CommandInitFunction = (program) => {
  program.addSubCommand<SetupOptions>({
    name: 'setup',
    description:
      'Sets up cert and hosts file settings for the relevant inner loop domain and HTTPS options ' +
      '(based on the server config).',
    options: {
      force: new Option('--force', 'Force execution of setup steps.'),
    },
    hideSharedOptions: ['cachePath', 'features'],
    getExecutor: () => import('./execute.js'),
  });
};
